import {createSelector} from 'reselect';

import * as aggregatedSettingsTypes from '../../consts/tnc/aggregatedSettingTypes';

const selectConsumer = (state) => state.consumer;

const selectAggregatedSettings = createSelector(selectConsumer, (state) => state.aggregatedSettings);

const selectConsumerAggregatedSettings = createSelector(
    selectAggregatedSettings,
    (aggregatedSettings) => aggregatedSettings?.consumerAggregatedSettings
);

const makeConsumerAggregatedSetting = (key) =>
    createSelector(selectConsumerAggregatedSettings, (cas) => cas?.find((item) => item.key === key)?.value);

const selectIsAggregatedSettingsFetched = createSelector(
    selectAggregatedSettings,
    (aggregatedSettings) => aggregatedSettings !== undefined
);

const selectIsGAEnabled = makeConsumerAggregatedSetting(aggregatedSettingsTypes.ENABLE_GA);

const selectIsAmplitudeEnabled = makeConsumerAggregatedSetting(aggregatedSettingsTypes.ENABLE_AMPLITUDE);

export {selectAggregatedSettings, selectIsAggregatedSettingsFetched, selectIsAmplitudeEnabled, selectIsGAEnabled};
